<template>
    <el-container>
        <el-header style="min-width:1500px" class="flex flex-v-center fixed flex-h-center header">
            <el-menu ref="topNav" :text-color="theme === 'dark' ? '#ffffff' : '#303030'" active-text-color="#E6A23C"
                :default-active="active" router class="el-menu-demo" mode="horizontal">
                <el-menu-item index="/" class="menu">
                    <el-image class="logo" :src="logo" fit="cover"></el-image>
                </el-menu-item>
                <el-menu-item index="/main" class="menu bold m-hover">{{ $t('首页') }}</el-menu-item>
                <el-submenu :class="{ 'active': active == '/main/pte' }" v-if="$store.state.mode == 'PTE'"
                    index="/main/pte" class="menu0 bold  m-hover">
                    <template slot="title">{{ $t('PTE练习') }}</template>
                    <sort-panel></sort-panel>
                </el-submenu>

                <!-- <el-menu-item index="/main/ccl" class="menu">CCL练习</el-menu-item> -->
                <!-- <el-menu-item index="/course" class="menu bold  m-hover">PTE课程</el-menu-item> -->
                <el-submenu :class="{ 'active': active == '/main/media' }"
                    v-if="$store.state.mode == 'PTE' && $store.state.lang != 'en'" index="/course" class="menu0 bold">
                    <template slot="title">{{ $t('PTE课程') }}</template>
                    <el-menu-item :key="index" v-for="(course, index) in $store.getters.getCourses('PTE')"
                        :index="'/main/media?tag=course&id=' + course.id" class="menu bold m-hover"
                        style="font-size: 14px !important;">{{
                            course.title }}</el-menu-item>
                </el-submenu>




                <el-submenu v-if="$store.state.mode == 'CCL'" index="/main/ccl" class="menu0 bold m-hover">
                    <template slot="title" class="m-hover">{{ $t('CCL练习') }}</template>
                    <div class="flex padding flex-h-center" style="width:100vw;">
                        <div class="margin-lx" v-for="index in 4" :key="index">
                            <div :class="{ 'margin-t': index1 > 0 }" class="mt1  pointer ul-hover"
                                v-for="(type, index1) in $store.getters.getTypes(1).slice((index - 1) * 3, index * 3)"
                                :key="type.id" @click="to('/main/ccl?tag=' + type.tag)">{{ type.title.replace("-", "")
                                }}
                            </div>
                        </div>
                    </div>
                </el-submenu>


                <el-submenu v-if="$store.state.mode == 'CCL'" index="/course" class="menu0 bold">
                    <template slot="title">{{ $t('CCL课程') }}</template>
                    <el-menu-item :key="index" v-for="(course, index) in $store.getters.getCourses('CCL')"
                        :index="'/main/media?tag=course&id=' + course.id" class="menu bold m-hover"
                        style="font-size: 14px !important;">{{
                            course.title }}</el-menu-item>
                </el-submenu>

                <el-menu-item index="/main/article" v-if="$store.state.lang != 'en'" class="menu bold  m-hover">{{
                    $t('备考入门')
                }}</el-menu-item>

            </el-menu>
            <search-input></search-input>

            <el-menu :default-active="active" :text-color="theme === 'dark' ? '#ffffff' : '#303030'"
                active-text-color="#E6A23C" router mode="horizontal">

                <!-- <el-menu-item class="flex flex-v-center">
                <el-tag class="flex flex-v-center radius-l">
                    <el-image style="height: 20px;"
                        src="https://upload.fireflyau.com/web_gwpte/pte/pte-index/discount.png"></el-image>
                    <span>考试报名优惠价 ￥1880 + 送VIP会员</span>
                </el-tag>
            </el-menu-item> -->

                <el-menu-item index="/main/certificate" class="flex flex-v-center"
                    v-if="$store.getters.getCertificate() == null">
                    <el-tag class="flex flex-v-center radius-l" type="primary">
                        <el-image style="height: 24px;width:24px ;" src="/web/image/vip.png?v=1"
                            fit="contain"></el-image>
                        <span>{{ $t('海澳学生认证') }}</span>
                    </el-tag>
                </el-menu-item>

                <el-menu-item v-if="$store.getters.getRole() == 0" index="/main/vip" class="flex flex-v-center">
                    <div class="flex flex-v-center bold  m-hover">
                        <el-image style="height: 24px; width:24px ;" fit="scale-down"
                            src="/web/image/vip1.png"></el-image>
                        <span>{{ $t('开通VIP') }}</span>
                    </div>
                </el-menu-item>
            </el-menu>


            <el-popover placement="bottom" :width="20" trigger="hover">
                <el-menu :text-color="theme === 'dark' ? '#ffffff' : '#303030'" active-text-color="#E6A23C" router>

                    <el-menu-item v-if="$store.state.mode == 'PTE'" style="padding: 0;" index="/main/mine"
                        class="bold center">
                        {{ $t('个人中心') }}
                    </el-menu-item>

                    <el-menu-item v-if="$store.state.mode == 'PTE' && $store.state.user && $store.state.user.teacher" style="padding: 0;"
                        index="/main/teacher/class" class="bold center">
                        {{ $t('教师中心') }}
                    </el-menu-item>

                    <el-menu-item v-if="$store.state.mode == 'CCL'" index="/main/personal" class="bold center">
                        {{ $t('个人信息') }}
                    </el-menu-item>

                    <el-menu-item v-if="$store.state.mode == 'CCL'" index="/main/certificate" class="bold center">
                        {{ $t('学生认证') }}
                    </el-menu-item>

                    <el-menu-item @click="exit()" class="bold center">
                        {{ $t('退出登录') }}
                    </el-menu-item>
                </el-menu>


                <div v-if="$store.state.user" class="margin-l" slot="reference" style="position:relative;">

                    <el-image v-if="$store.getters.getRole() == 1" src="/web/image/vip1.png"
                        style="width: 30px;height: auto; position: absolute;z-index: 10;top:-15px;right:-10px;transform: rotate(45deg);">
                    </el-image>


                    <div style="position: absolute;z-index: 10;bottom:5px;left:45px;display: flex;">
                        <el-image v-if="$store.state.user.certificate.status == 1" style="width: 25px;height: auto;"
                            src="/web/image/pte.png"></el-image>
                        <el-image v-if="$store.state.user.ccl_certificate.status == 1"
                            :style="{ 'margin-left': $store.state.user.certificate.status == 1 ? '-5px' : 0 }"
                            style="width: 25px;height: auto;" src="/web/image/ccl.jpg"></el-image>
                    </div>



                    <el-image style="width:50px; height: 50px;" fit="scale-down" class="radius-c" :src="avatar">
                    </el-image>
                </div>
            </el-popover>

            <div style="margin-top: 3px;margin-left: 60px;">
                <core-dialog />
            </div>
            <div style="margin-top: 3px;">
                <language />
            </div>

            <div class="margin-l" style="margin-top: 3px;">
                <dark-mode-toggle />
            </div>

        </el-header>


        <el-container class="main" :class="{ 'full': full }">

            <el-aside width="200px" style="position:fixed;top:100px; height: calc(100vh - 120px); overflow: scroll;"
                v-if="aside">
                <el-menu :text-color="theme === 'dark' ? '#ffffff' : '#303030'" active-text-color="#E6A23C" router
                    :default-active="active">
                    <el-menu-item index="/main" class="bold">{{ $t('首页') }}</el-menu-item>
                    <el-submenu v-if="$store.state.mode == 'PTE'" index="/main/mine" class="bold">
                        <template slot="title">
                            <el-menu-item style="margin-left: -20px;padding-left: 20px;" index="/main/mine"
                                class="bold">{{ $t('个人中心') }}</el-menu-item>
                        </template>
                        <el-menu-item v-if="$store.state.user.student" index="/main/homework" class="bold">{{ $t('我的作业')
                            }}</el-menu-item>
                        <el-menu-item index="/main/plan" class="bold">{{ $t('我的计划') }}</el-menu-item>
                        <el-menu-item index="/main/favorites" class="bold">{{ $t('我的收藏') }}</el-menu-item>
                        <el-menu-item index="/main/diy?tag=mine" class="bold">{{ $t('我的模板') }}</el-menu-item>
                        <el-menu-item index="/main/personal" class="bold">{{ $t('个人信息') }}</el-menu-item>
                    </el-submenu>
                    <el-menu-item v-if="$store.state.mode == 'PTE'" index="/main/pte?tag=prediction" class="bold">
                        {{ $t('PTE预测练习') }}</el-menu-item>
                    <el-menu-item v-if="$store.state.mode == 'PTE'" index="/main/practise" class="bold">
                        {{ $t('PTE机经练习') }}</el-menu-item>
                    <el-menu-item v-if="$store.state.mode == 'CCL'" index="/main/practise?tag=ccl" class="bold">{{
                        $t('CCL练习') }}</el-menu-item>


                    <el-menu-item v-if="$store.state.mode == 'CCL'" index="/main/mocks" class="bold">{{
                        $t('CCL模考')
                    }}</el-menu-item>

                    <el-menu-item @click="walkman()" index="" class="bold">{{ $t($store.state.mode + '随身听')
                    }}</el-menu-item>



                    <el-menu-item index="/main/wordbook" class="bold">{{ $t($store.state.mode + '单词表')
                        }}</el-menu-item>
                    <el-menu-item v-if="$store.state.mode == 'CCL'" index="/main/personal" class="bold">{{ $t('个人信息')
                    }}</el-menu-item>
                    <el-menu-item v-if="$store.state.mode == 'CCL'" index="/main/plan" class="bold">{{ $t('今日计划')
                    }}</el-menu-item>
                    <el-menu-item v-if="$store.state.mode == 'CCL'" index="/main/favorites" class="bold">{{ $t('我的收藏')
                    }}</el-menu-item>

                    <el-menu-item v-if="$store.state.mode == 'PTE'" index="/main/mocks" class="bold">
                        {{ $t('PTE模考') }}</el-menu-item>
                    <el-menu-item v-if="$store.state.mode == 'PTE'" index="/main/immersive" class="bold">
                        {{ $t('沉浸式练习') }}</el-menu-item>

                    <el-menu-item v-if="$store.state.mode == 'PTE' && $store.state.lang != 'en'" index="/main/game"
                        class="bold">
                        {{ $t('连词成句训练法') }}</el-menu-item>

                    <el-menu-item v-if="$store.state.mode == 'PTE'" index="/main/diy" class="bold">
                        {{ $t('DIY模板') }}</el-menu-item>



                    <!-- <el-menu-item index="/main/plan" class="bold">{{ $t('我的计划') }}</el-menu-item> -->

                    <el-menu-item v-if="$store.state.lang != 'en'" index="/main/documents" class="bold">{{ $t('资料下载')
                    }}</el-menu-item>
                    <el-menu-item index="/main/download" class="bold">
                        {{ $t('机经一键导出 PDF') }}</el-menu-item>

                    <el-menu-item index="/main/certificate" class="bold">{{ $t($store.state.mode + '学生认证')
                    }}</el-menu-item>
                    <el-menu-item index="/main/faq" class="bold">{{ $t('常见问题') }}</el-menu-item>
                    <!-- <el-menu-item index="/media?tag=article&id=1">{{$t('联系我们')}}</el-menu-item> -->
                    <el-menu-item index="" class="bold" @click="exit">{{ $t('退出登录') }}</el-menu-item>
                </el-menu>
            </el-aside>

            <el-main :style="{ 'margin-left': aside ? '200px' : '0' }">
                <keep-alive :include="include">
                    <router-view class="main-box"
                        :class="{ 'bg-withe': (this.$route.path != '/main/media' && this.$route.path != '/main/article') }"></router-view>
                </keep-alive>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import coreDialog from '../../components/CoreDialog.vue';
import darkModeToggle from '../../components/DarkModeToggle.vue';
import language from '../../components/Language.vue';
import searchInput from '../../components/SearchInput.vue';
import sortPanel from '../../components/SortPanel.vue';


export default {
    components: {
        searchInput, language, sortPanel, coreDialog, darkModeToggle
    },
    data: function () {
        return {
            include: ["search", "immersive", "immersive-list", "immersive-record", "favorites"],
            active: "/",
            aside: true,
            full: false,
            search: "",
            notification: null,
            count: 0,
            timer: null,
        }
    },

    computed: {
        logo: function () {
            return this.theme == "dark" ? "/web/image/logo-dark.png" : "/web/image/logo.png"
        },
        theme: function () {
            return this.$store.state.theme
        },
        avatar: function () {
            if (this.$store.state.user && this.$store.state.user.avatar) {
                if (this.$store.state.user.avatar.indexOf('http') === 0) {
                    return this.$store.state.user.avatar
                } else {
                    return this.$host + this.$store.state.user.avatar
                }
            }
            return this.$host + '/web/image/logo0.png'
        }
    },

    watch: {
        $route(route) {
            if (route.path == "/main/pte" || route.path == "/main/game" || route.path == "/main/vocabulary" || route.path == "/main/article" || route.path == "/main/media" || route.path.indexOf("/main/teacher") === 0) {
                this.aside = false;
            } else {
                this.aside = true;
            }

            if (route.path == "/main/pte" || route.path == "/main/game" || this.active.indexOf("/main/teacher") != -1) {
                this.full = true;
            } else {
                this.full = false;
            }
            if (route.path == '/main/ccl/record') {
                this.active = '/main/mocks'
            } else if (route.path != '/main/plan/add') {
                this.active = route.fullPath
            }
        }
    },

    created() {
        this.$store.dispatch("fetch_courses")
        this.get_notification()
        this.active = this.$route.path
        if (this.active == "/main/pte" || this.active == "/main/game" || this.active.indexOf("/main/teacher") === 0) {
            this.aside = false;
        }

        this.$bus.$on("toggle_menu", () => {
            this.$nextTick(() => {
                if (this.$refs.topNav) {
                    this.$refs.topNav.close("/main/pte");
                    this.$refs.topNav.close("/main/ccl");
                }
            })
        })

        this.$bus.$on("aside", (flag) => {
            this.aside = flag == undefined ? !this.aside : flag;
        })

        this.$bus.$on("full", (flag) => {
            this.full = flag == undefined ? !this.aside : flag;
        })
    },

    beforeDestroy() {
        if (this.notification) this.notification.close()
        if (this.timer) clearInterval(this.timer)
    },
    methods: {
        setLang(lang) {
            this.$store.commit("setLang", lang)
        },
        exit() {
            this.$store.commit("setUser", null);
            this.$router.replace("/");
        },
        to(url) {
            if (url == this.$route.fullPath) return
            if (url.indexOf("/main/ccl") != -1) {
                this.$store.commit("setMode", "CCL");
            } else if (url.indexOf("/main/pte") != -1) {
                this.$store.commit("setMode", "PTE");
            }
            this.$refs.topNav.close("/main");
            this.$router.replace(url);
        },

        walkman() {
            window.open("https://www.ptefighter.com/walkman")
        },
        get_count() {
            if (this.$store.state.user) {
                this.$http.post("/api/homework/count").then((count) => {
                    if (count == this.count) return
                    if (this.notification) {
                        this.notification.close()
                        this.notification = null
                    }
                    if (count > 0) {
                        this.notification = this.$notify({
                            duration: 0,
                            title: '作业提醒',
                            message: '您有' + count + '条作业需要完成',
                            showClose: false,
                            type: 'warning',
                            onClick: () => {
                                this.$router.push('/main/homework')
                            }
                        });
                    }
                    this.count = count
                })
            }
        },
        get_notification() {
            this.get_count()
            this.timer = setInterval(() => {
                this.get_count()
            }, 20000)
        }
    },
};
</script>

<style scoped>
.active>>>.el-submenu__title {
    color: #E6A23C !important;
    text-decoration: underline;
    text-underline-offset: 20px;
    text-decoration-thickness: 2px;
}

.logo {
    width: 100px;
}


.tag {
    color: #f66;
    line-height: 20px;
    padding: 5px 15px;
    display: inline-block;
    border-radius: 15px;
    border: 1px solid #f66;
}




.main-box {
    min-width: 950px;
    margin: 0 20px;
    padding: 20px;
}

.main-box.bg-withe {
    background-color: var(--bg-color);
    border-radius: 10px;
}


.main {
    padding: 100px 8% 0;
    position: relative;
}


.el-link.el-link--default:hover {
    color: #ffffff;
}

.el-link.el-link--default:after {
    border-color: #ffffff;
}

.el-divider {
    background-color: #606266;
}



.menu {
    padding: 0;
    margin: 10px 20px;
}

.menu0 {
    padding: 0;
    margin: 10px 0;
}
</style>
